export default(state = {
    distance: 512,
    rotationSpeed: Math.PI / 30,
    size: 16
}, action) => {
    switch (action.type) {
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/portfolio/battle-royale/reducers/lights.js